import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './WatchPage';
import { AppState } from '../../../../types/store';
import {
  getCurrentFeedType,
  getLayout,
  getWatchedDeviantsStrip,
} from '../../../../selectors/page';
import { BrowseLayout } from '../../../../../constants';
import { getIsCurrentStreamEmpty } from '../../../../selectors/stream';
import {
  removeDeviation,
  pushRemoveAllConfirmationModal,
} from '../../../../actions/dyw';

export type StateProps = Pick<
  Props,
  'feedType' | 'isStacked' | 'watchCount' | 'isEmpty'
>;
export type DispatchProps = Pick<
  Props,
  'removeDeviation' | 'removeAllFromStack'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> =
  state => ({
    feedType: getCurrentFeedType(state),
    isStacked: getLayout(state) === BrowseLayout.Stacked,
    watchCount: getWatchedDeviantsStrip(state)?.estTotal ?? 0,
    isEmpty: getIsCurrentStreamEmpty(state),
  });

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  removeDeviation,
  removeAllFromStack: pushRemoveAllConfirmationModal,
};

export default connect(mapStateToProps, mapDispatchToProps);
